module.exports = __webpack_public_path__ + "media/images/logos/logo-enbilab-77f6ea317533553da5687553f14cce4f.svg";